import styled from '@emotion/styled';
import { css, Box } from 'theme-ui';
import { BASIC_CONTAINER_WIDTH } from '../../consts/style-consts';

const RegionsContainer = styled(Box)(
  css({
    width: BASIC_CONTAINER_WIDTH,
    display: 'grid',
    gridTemplateColumns: ['1fr 1fr', '1fr 1fr', '1fr 1fr', '1fr 1fr 1fr'],
    gap: ['12px', '20px'],
    justifyContent: 'left',
    justifyItems: 'left',
  }),
);

export default RegionsContainer;
